/**
 * Video - Brightcove Player
 *
 * @see https://github.com/brightcove/react-player-loader
 *
 * @todo Replace hardcoded accountId
 */

import React from 'react'
import ReactPlayerLoader from '@brightcove/react-player-loader'

export type VideoProps = {
  accountId?: string
  autoplay?: boolean
  playerId?: string
  videoId: string
}

export const BrightcoveVideo = ({
  accountId = '1301119679001',
  autoplay = false,
  playerId = 'ryVPzahIb',
  videoId
}: VideoProps) => {
  return (
    <ReactPlayerLoader
      accountId={accountId}
      embedOptions={{
        responsive: true
      }}
      options={{
        autoplay
      }}
      videoId={videoId}
      playerId={playerId}
    />
  )
}
export default BrightcoveVideo
